import React from "react";
import useSmartviewManager from "./use-smartview-manager";
import useOnSmartviewMount from "./use-on-smartview-mount";

export default function useCurrentSmartview() {
    const manager = useSmartviewManager();

    const [smartview, setSmartview] = React.useState(manager.smartview);

    const handleChange = () => {
        setSmartview(manager.smartview);
    }

    useOnSmartviewMount(() => {
        handleChange();
    })

    React.useEffect(() => {
        handleChange();
    }, []);

    return [smartview, setSmartview];
}
